import { Checkbox, FormControl, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, makeStyles, TextField } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import React, { useEffect, useMemo, useState } from 'react';
const useStyles = makeStyles((theme) => ({
    selectList: {
        overflow: 'auto',
        borderRadius: 4,
        background: theme.palette.background.paper,
        border: '1px solid #ced4da',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
            transition: 0,
        },
        '& .MuiListSubheader-root': {
            background: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            marginTop: '-4px',
            padding: '4px 16px',
        },
        '.gts-page &': {
            borderRadius: 16,
        },
    },
    selectListError: {
        borderColor: theme.palette.error.main,
    },
    selectListDisabled: {
        backgroundColor: theme.palette.grey[300],
    },
    multilineSubheader: {
        '& .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderColor: '#fff',
        },
        '& .MuiInputBase-input': {
            color: '#fff',
        },
    },
    fullWidth: {
        width: '100%',
        minWidth: '100%',
    }
}));
function GroupedMultiLineSelectList(props) {
    var _a;
    const classes = useStyles();
    const snackbar = useSnackbar();
    const [selected, setSelected] = useState(props.selected);
    const [searchText, setSearchText] = useState();
    const [searchOpen, setSearchOpen] = useState(false);
    const getOptionValue = (o) => typeof props.valueSelector == 'function' ? props.valueSelector(o) : o[props.valueSelector];
    const getOptionText = (o) => typeof props.textSelector == 'function' ? props.textSelector(o) : o[props.textSelector];
    const optionGroups = useMemo(() => searchText && searchOpen ? props.optionGroups.map(o => (Object.assign(Object.assign({}, o), { options: o.options.filter(o => getOptionText(o).toLowerCase().includes(searchText.toLowerCase())) }))) : props.optionGroups, [props.optionGroups, searchOpen, searchText]);
    useEffect(() => {
        setSelected(selected.filter(s => props.optionGroups.findIndex(o => o.group == s.group && o.options.findIndex(o => getOptionValue(o) == s.value) >= 0) >= 0));
    }, [props.optionGroups, props.valueSelector]);
    useEffect(() => {
        if (props.onChange && !_.isEqual(_.orderBy(selected), _.orderBy(props.selected)))
            props.onChange(selected.filter(s => props.optionGroups.findIndex(o => o.group == s.group && o.options.findIndex(o => getOptionValue(o) == s.value) >= 0) >= 0));
    }, [selected]);
    const listClass = useMemo(() => `${classes.selectList}${props.error ? ` ${classes.selectListError}` : ''}${props.disabled ? ` ${classes.selectListDisabled}` : ''}`, [props.error, props.disabled]);
    return (React.createElement(FormControl, { fullWidth: true, variant: props.variant, className: "multiselect-wrapper", error: props.error, disabled: props.disabled },
        React.createElement(List, { className: listClass, style: { height: `${(_a = props.heightPx) !== null && _a !== void 0 ? _a : 300}px` }, subheader: !props.title ? undefined : React.createElement(React.Fragment, null, props.title || props.searchable ?
                React.createElement(ListSubheader, { className: classes.multilineSubheader }, !props.searchable || !searchOpen ? React.createElement(React.Fragment, null,
                    React.createElement(ListItemText, { primary: typeof props.title == "function" ? props.title(selected) : props.title }),
                    props.searchable || selected.length ?
                        React.createElement(ListItemSecondaryAction, null,
                            props.searchable ? React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSearchOpen(true) },
                                React.createElement(Search, { htmlColor: "#fff" })) : null,
                            selected.length ? React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSelected([]) },
                                React.createElement(Close, { htmlColor: "#fff" })) : null) : null) : React.createElement(React.Fragment, null,
                    React.createElement(ListItemText, { primary: React.createElement(TextField, { disabled: props.disabled, value: searchText, onChange: (e) => setSearchText(e.target.value), style: { color: '#fff', width: searchText ? 'calc(100% - 96px)' : 'calc(100% - 48px)' } }) }),
                    React.createElement(ListItemSecondaryAction, null,
                        React.createElement(IconButton, { disabled: props.disabled, onClick: () => setSearchOpen(false) },
                            React.createElement(Search, { htmlColor: "#fff" }))))) : null) }, optionGroups.map(({ group, options }, gi) => (React.createElement(React.Fragment, null,
            options.map((o, i) => {
                let value = getOptionValue(o);
                let text = getOptionText(o);
                return (React.createElement("div", { key: `${group}_${i}`, onClick: () => {
                        if (props.disabled || (props.disableOption && props.disableOption(o)))
                            return;
                        const old = [...selected];
                        let newSelected = [];
                        if (selected.findIndex(s => s.group === group && s.value === value) >= 0) {
                            newSelected = [...selected.filter(x => !(x.value === value && x.group == group) && optionGroups.findIndex(g => g.group === x.group && g.options.findIndex(p => getOptionValue(p) === x.value) >= 0) >= 0)];
                        }
                        else {
                            newSelected = [...selected.filter(x => optionGroups.findIndex(g => g.group === x.group && g.options.findIndex(p => getOptionValue(p) == x.value) >= 0) >= 0), { group, value }];
                        }
                        if (props.maxSelected && newSelected.length > props.maxSelected && props.maxSelectedAlertText) {
                            snackbar.enqueueSnackbar(props.maxSelectedAlertText, { variant: 'warning', autoHideDuration: 5000 });
                        }
                        else
                            setSelected(newSelected);
                    } },
                    React.createElement(ListItem, { dense: true, button: true, disabled: props.disabled || (props.disableOption && props.disableOption(o)) },
                        React.createElement(ListItemIcon, null,
                            React.createElement(Checkbox, { edge: "start", checked: selected.findIndex(s => s.group == group && s.value == value) >= 0, tabIndex: -1, disableRipple: true })),
                        React.createElement(ListItemText, { primary: text }),
                        props.endAdornment ? React.createElement(ListItemSecondaryAction, null, props.endAdornment(o)) : null)));
            }),
            gi < optionGroups.length - 1 ? React.createElement("hr", { className: "my-1" }) : null))))));
}
;
/**
 * @deprecated
 * @param props
 * @returns
 */
function GroupedDropdownSelectList(props) {
    return null;
}
export default function GroupedMultiSelectList(props) {
    return React.createElement(React.Fragment, null, 'multiline' in props ? React.createElement(GroupedMultiLineSelectList, Object.assign({}, props)) : React.createElement(GroupedDropdownSelectList, Object.assign({}, props)));
}
